import React from 'react';

import useTranslate from '../../../common/hooks/useTranslate';

import IdentityManager from '../../../common/services/identity/IdentityManagerFactory';

import LogoSize from '../../../common/services/config/brandingStore';

import { ILogin } from '../types/ILogin';

import Button from '../../ui/button/button';

import './login.scss';

const Login: React.FC<ILogin> = ({ notAuth }) => {
  const { t } = useTranslate();

  const identity = IdentityManager.getManager();

  const handleSignIn = () => {
    identity.signIn();
  };

  const handleSignOut = () => {
    identity.signOut();
  };

  return (
    <div className='login-wrapper'>
      <img src={'/branding/logoLogin.png'} alt='Logo' style={{width: LogoSize.logo_login_size}} />
      <span className='login-text'>{notAuth ? t('LOGIN.NOT_AUTHORIZED') : t('LOGIN.WELCOME')}</span>

      {identity.hasMfaSetup() &&
        <div className={'login-setup-authn'} role="button" onClick={() => identity.mfaSetup()}>{t('LOGIN.SETUP_MFA')}</div>}

      <Button buttonStyle='button-wrapper button-wrapper-oval' handleClick={notAuth ? handleSignOut : handleSignIn}>
        {notAuth ? t('LOGIN.SIGN_OUT') : t('LOGIN.BUTTON_TEXT')}
      </Button>

      {identity.hasForgotPassword() &&
        <div className={'login-forgot-password'} role="button" onClick={() => identity.forgotPassword()}>{t('LOGIN.FORGOT_PASSWORD')}</div>}

      <span className='copyright hidden-mobile'>&#169; {t('LOGIN.COPYRIGHT')}</span>
    </div>
  );
};

export default Login;
